// 火山鉴权
import CryptoJS from 'crypto-js';
import Base from './base';

const X_CA_SIGNATURE = 'x-apig-ca-signature';
const X_CA_SIGNATURE_HEADERS = 'x-apig-ca-signature-headers';
const form = 'application/x-www-form-urlencoded';
const hasOwnProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

/**
 * API Gateway Client
 */
export default class Client extends Base {
  constructor(key, secret, stage = 'RELEASE') {
    super();
    this.appKey = key;
    this.appSecret = secret;
    this.stage = stage;
  }

  buildStringToSign(method, headers, signedHeadersStr, url, data) {
    const lf = '\n';
    const list = [method, lf];

    const {accept} = headers;
    if (accept)
      list.push(accept);
    else {
      list.push('application/json');
    }
    list.push(lf);

    const contentMD5 = headers['content-md5'];
    if (contentMD5)
      list.push(contentMD5);
    list.push(lf);

    const contentType = headers['content-type'] || '';

    if (contentType)
      list.push(contentType);
    list.push(lf);

    const {date} = headers;
    if (date)
      list.push(date);
    list.push(lf);

    if (signedHeadersStr) {
      list.push(signedHeadersStr);
      list.push(lf);
    }

    if (contentType.startsWith(form))
      list.push(this.buildUrl(url, data));
    else
      list.push(this.buildUrl(url));

    return list.join('');
  }

  sign(stringToSign) {
    const key = CryptoJS.enc.Utf8.parse(this.appSecret);
    const hmac = CryptoJS.HmacSHA256(stringToSign, key);
    const base64String = CryptoJS.enc.Base64.stringify(hmac);
    return base64String;
  }

  // eslint-disable-next-line class-methods-use-this
  md5(content) {
    const wordArray = CryptoJS.enc.Utf8.parse(content);
    const md5Hash = CryptoJS.MD5(wordArray);
    const base64String = CryptoJS.enc.Base64.stringify(md5Hash);
    return base64String;
  }

  // eslint-disable-next-line class-methods-use-this
  getSignHeaderKeys(headers, signHeaders) {
    const keys = Object.keys(headers).sort();
    const signKeys = [];
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      if (key.startsWith('x-apig-ca-') || hasOwnProperty(signHeaders, key))
        signKeys.push(key);
    }
    return signKeys.sort();
  }

  // eslint-disable-next-line class-methods-use-this
  buildUrl(parsedUrl, data) {
    const toStringify = Object.assign({}, parsedUrl.query, data);
    let result = parsedUrl.pathname;
    if (Object.keys(toStringify).length) {
      const keys = Object.keys(toStringify).sort();
      // 当参数为空的时候不加等号
      // const list = keys.map(key => toStringify[key] !== undefined && toStringify[key] !== null && (`${toStringify[key]}`)
      const list = keys.map(key => toStringify[key] !== undefined && toStringify[key] !== null
        ? `${key}=${toStringify[key]}`
        : `${key}=`,
      );
      result += `?${list.join('&')}`;
    }

    return result;
  }

  buildHeaders(headers = {}, signHeaders) {
    return Object.assign({
      'x-apig-ca-timestamp': Date.now(),
      'x-apig-ca-key': this.appKey,
      'x-apig-ca-stage': this.stage,
      // 'accept': 'application/json',
    }, headers, signHeaders);
  }

  // eslint-disable-next-line class-methods-use-this
  getSignedHeadersString(signHeaders, headers) {
    return signHeaders.map(key => `${key}:${headers[key]}`).join('\n');
  }

  request(method, urlObj, opts, originData) {
    const {signHeaders} = opts;
    const headers = this.buildHeaders(opts.headers, signHeaders);
    const requestContentType = headers['content-type'] || '';
    if (method === 'POST' && !requestContentType.startsWith(form))
      headers['content-md5'] = this.md5(opts.data);
    // headers['x-apig-ca-signature-method'] = method;
    const signHeaderKeys = this.getSignHeaderKeys(headers, signHeaders);
    headers[X_CA_SIGNATURE_HEADERS] = signHeaderKeys.join(',');
    const signedHeadersStr = this.getSignedHeadersString(signHeaderKeys, headers);
    const stringToSign = this.buildStringToSign(method, headers, signedHeadersStr, urlObj, originData);
    headers[X_CA_SIGNATURE] = this.sign(stringToSign);
    return headers;
  }
}
